import { useAuth } from '@/logic/state';

import { isWalletFeatureEnabled } from '@/constants/wallet';
import shallow from 'zustand/shallow';
import { useGetBalance, useGetDetailedBalanceQuery } from '../services/_api';
import { E_WALLET } from '../services/types';

// This custom hook is used to call get balance api

export const useWalletBalance = () => {
  const [user, setUser] = useAuth(s => [s.user, s.setUser], shallow);

  const isUserAuth = Boolean(user?.token);

  const {
    isFetching: isFetchingBalance,
    isSuccess: isSuccessBalance,
    isError: isErrorBalance,
    refetch: refetchBalance,
  } = useGetBalance(
    {
      params: {
        walletType: E_WALLET,
      },
    },
    {
      enabled: isUserAuth && isWalletFeatureEnabled,
      onSuccess: ({ balance, transaction }) => {
        setUser(prevState => ({
          ...prevState,
          walletBalance: balance ?? 0,
          walletTransaction: transaction ?? null,
        }));
      },
    }
  );

  useGetDetailedBalanceQuery(
    {},
    {
      enabled: isUserAuth,
      onSuccess: ({ cashbackWalletBalance, eWalletBalance, totalBalance }) => {
        setUser(prevState => ({
          ...prevState,
          walletDetailedBalance: eWalletBalance,
          cashbackDetailedBalance: cashbackWalletBalance,
          totalDetailedBalance: totalBalance,
        }));
      },
    }
  );

  return {
    isFetchingBalance,
    isSuccessBalance,
    isErrorBalance,
    refetchBalance,
  };
};
